import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = unauth, obj = auth
    const [loading, setLoading] = useState(true);

    async function refresh() {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data.user);
        } catch {
            setUser(false);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        // CRITICAL: Si venimos del callback OAuth de Google, saltamos el /auth/me:
        // AuthCallback intercambia el session_id primero y luego establece la sesión.
        if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        refresh();
    }, []);

    function setUserFromCallback(u) {
        setUser(u);
        setLoading(false);
    }

    async function login(email, password) {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            if (data.token) localStorage.setItem("gf_token", data.token);
            setUser(data.user);
            return { ok: true };
        } catch (e) {
            return { ok: false, error: formatApiError(e, "Error al iniciar sesión") };
        }
    }

    async function register({ name, apellidos, telefono, email, password, tipoCliente }) {
        try {
            const { data } = await api.post("/auth/register", { name, apellidos, telefono, email, password, tipo_cliente: tipoCliente });
            if (data.token) localStorage.setItem("gf_token", data.token);
            setUser(data.user);
            return { ok: true, welcomeCredits: !!data.welcome_credits_granted };
        } catch (e) {
            return { ok: false, error: formatApiError(e, "Error al registrar") };
        }
    }

    async function logout() {
        try { await api.post("/auth/logout"); } catch {}
        localStorage.removeItem("gf_token");
        setUser(false);
    }

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, setUserFromCallback }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
